import { IAvailable } from '@src/models/auth';
import { AppContext } from '@src/providers/App';
import { withTags } from '@src/utils/tags';
import { useContext, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { userEffectorModel } from '../stores';

/**
 * Хук для определения доступности, в котором можно настроить
 * отображение для определенных тегов или роутов
 *
 * @param {IAvailable} param  параметр настройка для определения доступности
 * @returns {boolean} флаг соответствующий значению доступности
 */
export const useAvailable = (param?: IAvailable[]) => {
  const { isAuthZone } = useContext(AppContext);
  const { $userStore: user } = useUnit(userEffectorModel);

  const available = useMemo<boolean>(() => {
    if (!param) {
      return true;
    }

    if (param && !Array.isArray(param)) {
      return false;
    }

    const fullPathname = location.pathname + location.search;
    const isAvailablePath = param?.some((p) => {
      /** Определяем совпадение path */
      const isAvailablePath = p.exact ? p.path === fullPathname : fullPathname.includes(p.path);
      if (!isAvailablePath) return false;

      /** Здесь обрабатываем триггеры */
      const isAuthZoneTrigger =
        typeof p.trigger?.isAuthZone === 'undefined' ? true : p.trigger.isAuthZone === isAuthZone;

      // Если нет тегов ограничения
      if (!p.tags || (Array.isArray(p.tags) && p.tags.length === 0)) {
        /** Возвращаем набор значений триггеров через && */
        return isAuthZoneTrigger;
      }

      if (!user) return false;

      /** Обрабатываем теги */
      const withTagsAvailable = withTags({ tags: p.tags, user });

      return withTagsAvailable && isAuthZoneTrigger;
    });

    return !!isAvailablePath;
  }, [isAuthZone, param, user]);

  return available;
};
